function RichardsonMode() {

}

RichardsonMode.funcs = {

    init: function(accept, reject) {
        var that = RichardsonMode.funcs;
        if (that.isMobile()) {
            document.getElementById("main_container").style.display = "none";
            document.getElementById("debug").style.display = "none";
            
            UIkit.modal.alert('Richardson mobile is still under development. We apologize for any inconvenience it might cause. Thank you for your patience as we improve the site.').then(function() {
                accept()
            });
        } else {
            that.desktop();
        }
    },

    initialize: function(userData) {
        var that = RichardsonMode.funcs;

        if (that.isMobile()) {
            RichardsonMode.funcs.mobile(userData, true);
        } else {
            RichardsonMode.funcs.desktop();
        }
    },

    isMobile: function() {
        // alternative
        var mobile = ['iphone','ipad','android','blackberry','nokia','opera mini','windows mobile','windows phone','iemobile']; 
        for (var i in mobile) {
            if (navigator.userAgent.toLowerCase().indexOf(mobile[i].toLowerCase()) > 0) {
                return true;  
            }
        }

        // alternative for Tablet/Ipad with Computer OS
        var isTouchDevice = 'ontouchstart' in window || (navigator.msMaxTouchPoints > 0);
        if (isTouchDevice) {
            return true;
        }

        // nothing found.. assume desktop
        return false;
    },

    mobile: function(userdata, isEmbedded) {
        let that = RichardsonMode.funcs;
        let { material_id, mobileURL, isMagentoVersionTwo, magentoURL } = ub.config;
        let session = _.isNull(userdata) ? false : btoa(JSON.stringify(userdata));
        
        let param = {
            isMagentoVersionTwo,
            session,
            magentoURL
        }
        
        let url = `${mobileURL}/builder/0/${material_id}?customize-uniform&options=${JSON.stringify(param)}`;

        if (typeof ub.config.savedDesignInfo === "object") {
            let savedDesignId = ub.config.savedDesignInfo.savedDesignID;
            url = `${mobileURL}/my-saved-design/${savedDesignId}/render?options=${JSON.stringify(param)}`;
        }

        // window.location.href = url;

        that.updateIframeAttribute();
        that.updateIframeSrc(url);
    },

    desktop: function() {
        _.delay(function() {
            window.ub.initialize();
        }, 3000);
    },

    updateIframeAttribute: function() {
        var postData = {
            action: "update_attribute",
            attributes: {
                "scrolling": "yes"
            }
        };

        parent.postMessage(postData, ub.config.magentoURL);
    },

    updateIframeSrc: function(url) {
        var postData = {
            action: "update_attribute",
            attributes: {
                "src": url
            }
        };

        parent.postMessage(postData, ub.config.magentoURL);
    }
};